import styled from "styled-components";

export const PaginationActionsContainer = styled.div`
  flex-shrink: 0;
  margin-left: 2.5em;
`;
